import { d as r } from "./define-BoCZvwvE.js";
const d = r(() => ({ selected: false, selectedVariantId: null, selectedPrice: 0, message: "", touched: false, errorMessage: "", priceStateRequestHandler: null, init() {
  const e = Number(this.$el.dataset.defaultVariantId), t = Number(this.$el.dataset.defaultVariantPrice);
  e && !Number.isNaN(e) && (this.selected = true, this.selectedVariantId = e, this.selectedPrice = Number(t) || 0), this.priceStateRequestHandler = () => {
    this.syncPrice();
  }, window.addEventListener("product:price-state-request", this.priceStateRequestHandler), this.$nextTick(() => {
    this.syncPrice();
  });
  const s = this.$el.closest("form");
  s && this.$el.dataset.validationInitialized !== "true" && (this.$el.dataset.validationInitialized = "true", s.addEventListener("submit", (i) => {
    this.validate() || (i.preventDefault(), i.stopImmediatePropagation(), this.$nextTick(() => {
      var _a;
      (_a = this.$refs.messageInput) == null ? void 0 : _a.focus();
    }));
  }, true));
}, destroy() {
  this.priceStateRequestHandler && window.removeEventListener("product:price-state-request", this.priceStateRequestHandler);
}, selectCard(e, t = 0) {
  this.selected = true, this.selectedVariantId = Number(e), this.selectedPrice = Number(t) || 0, this.touched && this.validate(false), this.syncPrice();
}, skipCard() {
  this.selected = false, this.selectedVariantId = null, this.selectedPrice = 0, this.message = "", this.touched = false, this.errorMessage = "", this.syncPrice();
}, syncPrice() {
  window.dispatchEvent(new CustomEvent("product:option-price-change", { detail: { key: "greeting_card", price: this.selected ? this.selectedPrice : 0 } }));
}, isSelected(e) {
  return this.selectedVariantId === Number(e);
}, validate(e = true) {
  return e && (this.touched = true), this.selected ? this.message.trim() ? (this.errorMessage = "", true) : (this.errorMessage = this.$el.dataset.messageRequired || "Please write your message.", false) : (this.errorMessage = "", true);
}, onMessageInput() {
  const e = this.$refs.messageInput;
  e && (e.style.height = "auto", e.style.height = `${e.scrollHeight}px`), this.touched && this.validate(false);
}, get hasMessageError() {
  return this.selected && this.touched && !this.message.trim();
}, get selectedVariantValue() {
  return !this.selected || !this.selectedVariantId ? "" : String(this.selectedVariantId);
}, get messageValue() {
  return this.selected ? this.message : "";
} }));
export {
  d as g
};
